import React, { useCallback } from "react";
import { SupportedLanguage } from "../../../utils/translations/supported-languages";
import { Picklist, PicklistItem } from "../common/picklist/Picklist";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { setLanguage } from "../../../redux/slices/session";
import { translations } from "../../../utils/translations/translations-manager";

const languages: Record<SupportedLanguage, PicklistItem<SupportedLanguage>> = {
  'it': { key: 'it', value: 'it' },
  'en': { key: 'it', value: 'en' }
}

const languageClassnames: Record<SupportedLanguage, string> = {
  'it': 'fi-it',
  'en': 'fi-gb'
}

const languagesStrings: Record<SupportedLanguage, () => string> = {
  'it': () => translations.texts.language_italian.toString(),
  'en': () => translations.texts.language_english.toString()
}

export function LanguageSelector(): JSX.Element {
  const language = useSelector((state: RootState) => state.auth.language)
  const dispatch: AppDispatch = useDispatch()

  const onChange = useCallback((value: SupportedLanguage | undefined) => {
    if (value) {
      dispatch(setLanguage(value))
    }
  }, [dispatch])
  return <Picklist picks={Object.values(languages)} value={language} onChange={(value: PicklistItem<SupportedLanguage> | undefined) => { onChange(value ? value.value : undefined) }}
    renderer={(value) => <div className="flex flex-row"><span className={`fi ${languageClassnames[value]} mr-2`}></span>{languagesStrings[value]()}</div>} />
}